import { useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT_PX } from "../Config/uiConfig";

/**
 * Determines if the current device is a mobile device based on its width.
 * @returns A boolean indicating whether the device is mobile.
 */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width:${MOBILE_BREAKPOINT_PX}px)`);
}
